<template>
  <form id="form-contact-home" class="row" @submit.prevent="sendForm" method="POST">
    <input type="hidden" name="_token" :value="csrf" />
    <input type="hidden" name="region_id" :value="form.region_id" />
    <input type="hidden" name="method_contact" :value="form.methodContact" />
    <div class="col-12">
      <!--      <h5 class="font-weight-bold color-palette-2">¿Dónde quieres tu casa propia?</h5>-->
      <h5 class="font-weight-bold color-palette-2">¿Dónde quieres tu casa/dpto propio?</h5>
      <v-select-c
        id="select-regions"
        style="border-radius: 5px !important"
        v-model="$v.form.region_id.$model"
        :options="regions"
        label="name"
        :class="!$v.form.region_id.$anyError ? '' : 'form-error'"
        :reduce="(name) => name.id"
        placeholder="¿Dónde Vives?"
      >
      </v-select-c>
      <div class="error-data" v-if="$v.form.region_id.$dirty">
        <span v-if="!$v.form.region_id.required">Campo necesario</span>
      </div>
    </div>
    <div class="col-12" data-app>
      <h5 class="font-weight-bold color-palette-2">¿Cuál es tu renta? (Puedes complementar)</h5>
      <input
        @input="handleInputRange"
        name="salary"
        v-model="$v.form.salary.$model"
        type="range"
        class="form-control-range my-2"
        id="formControlRange"
        min="0"
        max="2500000"
        step="50000"
        value="950000"
      />
      <span
        id="spanMonto"
        class="bg-color-palette-2 px-3 text-white"
        style="border-radius: 6px; padding: 3.5px 17.8px"
      >
        ${{ numberRangeFormatted }}
      </span>
      <!-- <v-range-slider v-model="pruebaRange" :model-value="[0, 1]" min="0" max="3" :step="1" show-ticks="always"
        thumb-label="always" tick-size="4">
        <template v-slot:thumb-label="{ modelValue }">
          250 - {{ modelValue }} - {{ pruebaRange }}
        </template>
      </v-range-slider> -->
      <!-- <div class="range-value" id="rangeV">
        <span>{{ form.salary }}</span>
      </div>
      <input v-model="$v.form.salary.$model" class="form-control p-0" @input="handleInputRange" id="range" type="range"
        min="0" max="2500000" step="50000"> -->
      <!-- <div class="range-wrap">
      </div> -->
    </div>
    <div class="col-12">
      <h5 class="font-weight-bold color-palette-2">Déjanos tus datos</h5>
    </div>
    <div class="col-12 col-md-6">
      <input
        type="text"
        placeholder="Nombre"
        name="name"
        v-model.trim="$v.form.name.$model"
        :class="!$v.form.name.$anyError ? 'form-control w-100' : 'form-control w-100 form-error'"
      />
      <div class="error-data" v-if="$v.form.name.$dirty">
        <span v-if="!$v.form.name.required">Campo necesario</span>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <input
        type="text"
        placeholder="Email"
        name="email"
        v-model.trim="$v.form.email.$model"
        :class="!$v.form.email.$anyError ? 'form-control w-100' : 'form-control w-100 form-error'"
      />
      <div class="error-data" v-if="$v.form.email.$dirty">
        <span v-if="!$v.form.email.required">Campo necesario</span>
        <span v-if="!$v.form.email.email">Email inválido</span>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <input
        type="text"
        placeholder="Rut"
        name="rut"
        v-model.trim="$v.form.rut.$model"
        v-rut:live
        :class="!$v.form.rut.$anyError ? 'form-control w-100' : 'form-control w-100 form-error'"
      />
      <div class="error-data" v-if="$v.form.rut.$dirty">
        <span v-if="!$v.form.rut.rutValidation || !$v.form.rut.minLength">RUT Inválido</span>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <input
        type="text"
        placeholder="Teléfono"
        name="phone"
        maxlength="9"
        @keypress="onlyNumber"
        v-model.trim="$v.form.phone.$model"
        :class="!$v.form.phone.$anyError ? 'form-control w-100' : 'form-control w-100 form-error'"
      />
      <div class="error-data" v-if="$v.form.phone.$dirty">
        <span v-if="!$v.form.phone.required">Campo necesario</span>
        <span v-if="!$v.form.phone.minLength">Teléfono inválido</span>
        <span v-if="!$v.form.phone.maxLength">Teléfono inválido</span>
      </div>
    </div>
    <!--    <div class="col-12">
      <h5 class="font-weight-bold color-palette-2">¿Cómo quieres que te contactemos?</h5>
      <v-select-c
        id="select-method-contact"
        name="method_contact"
        style="border-radius: 5px !important"
        v-model="$v.form.methodContact.$model"
        :options="contact_options"
        label="text"
        :class="!$v.form.methodContact.$anyError ? '' : 'form-error'"
        :reduce="(text) => text.id"
        placeholder="Seleccione"
      >
      </v-select-c>
      <div class="error-data" v-if="$v.form.methodContact.$dirty">
        <span v-if="!$v.form.methodContact.required">Campo necesario</span>
      </div>
    </div>-->
    <div class="col-12">
      <privacy-consent
        id="home-modal-privacy"
        v-model="$v.form.privacy.$model"
        :invalid="$v.form.privacy.$dirty && !$v.form.privacy.accepted"
      />
    </div>
    <div class="col-12">
      <div class="col-12 col-md-5 ml-auto pr-0 pl-0 pl-md-3">
        <button
          type="submit"
          :disabled="formLoading"
          class="btn bg-color-palette-2 text-white btn-block"
        >
          {{ btnText }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
  import { required, minLength, email, maxLength } from 'vuelidate/lib/validators';
  import { rutValidator, rutInputDirective } from 'vue-dni';
  import PrivacyConsent from '../PrivacyConsent.vue';

  import Vue from 'vue';
  Vue.directive('rut', rutInputDirective);

  const accepted = (value) => value === true;

  export default {
    name: 'FormularioHomeModal',
    components: { PrivacyConsent },
    props: {
      regions: {
        type: Array,
        required: true,
      },
      /* showModal: {
      type: Boolean,
      required: true,
      default: false,
    }, */
    },
    data: () => ({
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      formLoading: false,
      btnText: 'Enviar',
      hasUfSaving: 0,
      hasRsh: 0,
      form: {
        name: '',
        rut: '',
        email: '',
        phone: '',
        region_id: '',
        methodContact: '.',
        salary: 950000,
        privacy: false,
      },
      contact_options: [
        { id: 'email', text: 'Email' },
        { id: 'telefono', text: 'Teléfono' },
        { id: 'whatsApp', text: 'WhatsApp' },
      ],
      seasons: {
        0: 'Winter',
        1: 'Spring',
        2: 'Summer',
        3: 'Fall',
      },
      icons: ['mdi-snowflake', 'mdi-leaf', 'mdi-fire', 'mdi-water'],
      pruebaRange: [0, 4],
      numberRangeFormatted: 0,
    }),
    mounted() {
      //this.setValue();
      //range.addEventListener("input", this.setValue);
      //const range = document.getElementById('range');
      //const rangeV = document.getElementById('rangeV');
      //document.addEventListener("DOMContentLoaded", setValue);
      //range.addEventListener('input', setValue);
      //this.setValue();
      this.numberRangeFormatted = this.formatNumber(this.form.salary);
    },
    methods: {
      sendForm() {
        this.$v.form.$touch();
        if (!this.$v.form.$invalid) {
          this.btnText = 'Enviando...';
          this.formLoading = true;
          const rutaForm = window.BASE_URL + '/add-contact-form-home';
          $('#form-contact-home').attr('action', rutaForm).submit();
        }
      },
      onlyNumber($event) {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
          // 46 is dot
          $event.preventDefault();
        }
      },
      handleInputRange(event) {
        //this.setValue();
        const numero = event.target.value;
        this.numberRangeFormatted = this.formatNumber(numero);
      },
      formatNumber(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      },
      season(val) {
        return this.icons[val];
      },
      /* setValue() {
      const range = document.getElementById('range');
      const rangeV = document.getElementById('rangeV');
      const newValue = Number((range.value - range.min) * 100 / (range.max - range.min));
      const newPosition = 20;
      console.log({ newValue, newPosition });
      rangeV.style.right = `${newPosition}px`;
    } */
    },
    validations: {
      form: {
        rut: {
          required,
          rutValidation: rutValidator,
          minLength: minLength(9),
        },
        name: {
          required,
        },
        phone: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(9),
        },
        email: {
          required,
          email,
        },
        region_id: {
          required,
        },
        methodContact: {
          //required,
        },
        salary: {
          required,
        },
        privacy: { accepted },
      },
    },
  };
</script>

<style scoped>
  .letter-small {
    font-size: 0.8rem !important;
  }

  input {
    height: 2rem !important;
    border-radius: 9px !important;
  }

  div.error-data {
    color: red;
    font-size: 0.7rem;
    margin-top: 0.25rem;
  }

  /* .range-value {
  position: absolute;
  top: 30%;

  & span {
    background-color: #134b6e;
    color: white;
    border-radius: 8px;
    padding: 2px 20px;
  }
} */

  @media (max-width: 639px) {
  }
</style>
